// extracted by mini-css-extract-plugin
module.exports = {"amenitiesSelection":"styles_amenitiesSelection__IYCgR","title":"styles_title__69WRi","optionsList":"styles_optionsList__V1gC0","option":"styles_option__LyBf4"};